var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoExhibitors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9587 36.1691C60.2184 36.2748 59.5415 35.7557 59.343 35.0346C58.1632 30.7495 54.4576 28.0087 50.3247 26.9508C49.6002 26.7653 49.0997 26.0735 49.2226 25.3357C49.3456 24.598 50.0446 24.0947 50.7711 24.2723C55.7423 25.4874 60.6315 28.8946 62.0426 34.6481C62.2207 35.3744 61.6991 36.0633 60.9587 36.1691Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3523 53.2613C28.0801 53.0891 28.802 53.5442 29.0541 54.2484C30.5873 58.5304 34.3187 61.1232 38.6668 61.5676C39.4108 61.6436 40.019 62.2423 40.019 62.9902C40.019 63.7381 39.4113 64.3505 38.6662 64.287C33.1752 63.8185 28.2817 60.4982 26.4047 54.8757C26.1678 54.1663 26.6245 53.4335 27.3523 53.2613Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9065 45.306C53.9598 44.8793 53.9998 44.4527 53.9998 43.9993C53.9998 43.546 53.9598 43.1193 53.9065 42.6927L56.7198 40.4927C56.9731 40.2927 57.0398 39.9327 56.8798 39.6393L54.2131 35.026C54.0931 34.8127 53.8665 34.6927 53.6265 34.6927C53.5465 34.6927 53.4665 34.706 53.3998 34.7327L50.0798 36.066C49.3865 35.5327 48.6398 35.0927 47.8265 34.7593L47.3198 31.226C47.2798 30.906 46.9998 30.666 46.6665 30.666H41.3331C40.9998 30.666 40.7198 30.906 40.6798 31.226L40.1731 34.7593C39.3598 35.0927 38.6131 35.546 37.9198 36.066L34.5998 34.7327C34.5198 34.706 34.4398 34.6927 34.3598 34.6927C34.1331 34.6927 33.9065 34.8127 33.7865 35.026L31.1198 39.6393C30.9465 39.9327 31.0265 40.2927 31.2798 40.4927L34.0931 42.6927C34.0398 43.1193 33.9998 43.5593 33.9998 43.9993C33.9998 44.4393 34.0398 44.8793 34.0931 45.306L31.2798 47.506C31.0265 47.706 30.9598 48.066 31.1198 48.3594L33.7865 52.9727C33.9065 53.186 34.1331 53.306 34.3731 53.306C34.4531 53.306 34.5331 53.2927 34.5998 53.266L37.9198 51.9327C38.6131 52.466 39.3598 52.906 40.1731 53.2393L40.6798 56.7727C40.7198 57.0927 40.9998 57.3327 41.3331 57.3327H46.6665C46.9998 57.3327 47.2798 57.0927 47.3198 56.7727L47.8265 53.2393C48.6398 52.906 49.3865 52.4527 50.0798 51.9327L53.3998 53.266C53.4798 53.2927 53.5598 53.306 53.6398 53.306C53.8665 53.306 54.0931 53.186 54.2131 52.9727L56.8798 48.3594C57.0398 48.066 56.9731 47.706 56.7198 47.506L53.9065 45.306ZM51.2665 43.026C51.3198 43.4394 51.3331 43.7193 51.3331 43.9993C51.3331 44.2793 51.3065 44.5727 51.2665 44.9727L51.0798 46.4793L52.2665 47.4127L53.7065 48.5327L52.7731 50.146L51.0798 49.466L49.6931 48.906L48.4931 49.8127C47.9198 50.2394 47.3731 50.5593 46.8265 50.786L45.4131 51.3594L45.1998 52.866L44.9331 54.666H43.0665L42.8131 52.866L42.5998 51.3594L41.1865 50.786C40.6131 50.546 40.0798 50.2393 39.5465 49.8393L38.3331 48.906L36.9198 49.4794L35.2265 50.1594L34.2931 48.546L35.7331 47.426L36.9198 46.4927L36.7331 44.986C36.6931 44.5727 36.6665 44.266 36.6665 43.9993C36.6665 43.7327 36.6931 43.426 36.7331 43.026L36.9198 41.5194L35.7331 40.586L34.2931 39.466L35.2265 37.8527L36.9198 38.5327L38.3065 39.0927L39.5065 38.186C40.0798 37.7593 40.6265 37.4393 41.1731 37.2127L42.5865 36.6393L42.7998 35.1327L43.0665 33.3327H44.9198L45.1731 35.1327L45.3865 36.6393L46.7998 37.2127C47.3731 37.4527 47.9065 37.7593 48.4398 38.1593L49.6531 39.0927L51.0665 38.5193L52.7598 37.8393L53.6931 39.4527L52.2665 40.586L51.0798 41.5194L51.2665 43.026ZM43.9998 38.666C41.0531 38.666 38.6665 41.0527 38.6665 43.9993C38.6665 46.946 41.0531 49.3327 43.9998 49.3327C46.9465 49.3327 49.3331 46.946 49.3331 43.9993C49.3331 41.0527 46.9465 38.666 43.9998 38.666ZM43.9998 46.666C42.5331 46.666 41.3331 45.466 41.3331 43.9993C41.3331 42.5327 42.5331 41.3327 43.9998 41.3327C45.4665 41.3327 46.6665 42.5327 46.6665 43.9993C46.6665 45.466 45.4665 46.666 43.9998 46.666Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.805 60.5676C52.6614 59.8336 53.1451 59.131 53.855 58.8957C58.0739 57.4976 60.621 53.6561 61.4654 49.4744C61.6134 48.7413 62.2786 48.206 63.0217 48.2909C63.7647 48.3758 64.3033 49.048 64.1632 49.7827C63.2048 54.8097 60.0531 59.8674 54.3797 61.572C53.6634 61.7872 52.9487 61.3016 52.805 60.5676Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6667 6.33398H7.33333V9.50065H32.6667V6.33398ZM34.25 22.1673V19.0007L32.6667 11.084H7.33333L5.75 19.0007V22.1673H7.33333V31.6673H23.1667V22.1673H29.5V31.6673H32.6667V22.1673H34.25ZM20 28.5007H10.5V22.1673H20V28.5007Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 22,
    width: 10,
    height: 7,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: -4.25,
    y: -2.66602,
    width: 48.5,
    height: 45.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoExhibitors);
export default __webpack_public_path__ + "static/media/no_exhibitors.d778c7fc.svg";
export { ForwardRef as ReactComponent };